import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Auto-detect API base so the same build works locally and on 85.x
const API_BASE =
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
    ? "http://localhost:5000"
    : ""; // same-origin in prod (85.x), i.e. /api/*

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${API_BASE}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      // Don’t crash if server returned HTML (e.g., 404 page)
      const ct = response.headers.get("content-type") || "";
      const data = ct.includes("application/json")
        ? await response.json()
        : { error: (await response.text()).slice(0, 200) };

      if (!response.ok) {
        setError(data?.error || `Login failed (${response.status})`);
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("is_admin", String(data.is_admin));
      navigate(data.is_admin ? "/admin/dashboard" : "/user/dashboard");
    } catch (err) {
      console.error(err);
      setError("Server error");
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center">
      {/* Background */}
      <div className="fixed inset-0 -z-10 overflow-hidden">
        <img
          src="https://latonacinema.com/wp-content/uploads/2025/06/cinema-hall-with-rows-of-grey-seats-in-darkness.jpg"
          alt="Латона Синема — фон"
          className="h-full w-full object-cover blur-sm scale-105"
        />
        {/* Cinematic purple + vignette */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2c204f]/70 via-black/60 to-[#6c56b5]/55" />
        <div className="absolute inset-0 pointer-events-none" style={{
          background: "radial-gradient(70% 60% at 50% 40%, rgba(0,0,0,0) 0%, rgba(0,0,0,.35) 60%, rgba(0,0,0,.65) 100%)"
        }} />
      </div>

      {/* Card */}
      <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-2xl w-full max-w-md border border-white/60">
        <div className="flex flex-col items-center mb-6 text-center">
          <img
            src="https://latonacinema.com/wp-content/uploads/2025/06/cropped-latonacinema.png"
            alt="Латона Синема — лого"
            className="h-24 mb-4 drop-shadow"
          />
          <h1 className="text-2xl font-extrabold text-gray-900 leading-snug">
            🎟️ Система за билетиране на Латона Синема
          </h1>
          <p className="text-sm text-gray-700 mt-2">
            Моля, въведете потребител и парола
          </p>
        </div>

        <form className="grid gap-4" onSubmit={handleLogin}>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-800">
              Потребителско име
            </label>
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="въведете потребителско име"
              className="w-full px-4 py-2 rounded-md bg-white border border-gray-300 text-gray-900 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-800">
              Парола
            </label>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="въведете парола"
              className="w-full px-4 py-2 rounded-md bg-white border border-gray-300 text-gray-900 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
            />
          </div>

          {error && (
            <div className="text-red-600 text-sm bg-red-50 border border-red-200 rounded-md p-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="w-full py-2 rounded-md text-white font-semibold
                       bg-gradient-to-r from-purple-700 to-indigo-700
                       hover:from-purple-800 hover:to-indigo-800
                       focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            Вход
          </button>
        </form>

        {/* Small footer / hint */}
        <p className="mt-4 text-xs text-center text-gray-600">
          Ако имате затруднения с входа, свържете се с администратор.
        </p>
      </div>
    </div>
  );
}
